import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axios";


export const fetchStaffs = createAsyncThunk(
  'staff/fetchStaffs',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('v1/accounts/staff/', { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const createStaff = createAsyncThunk(
  'staff/createStaff',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('v1/accounts/staff/', data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const updateStaff = createAsyncThunk(
  'staff/updateStaff',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`v1/accounts/staff/${data.id}/`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const fetchStaff = createAsyncThunk(
  'staff/fetchStaff',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`v1/accounts/staff/${id}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
  
// For drop down list
export const fetchStaffMini = createAsyncThunk(
  'staff/fetchStaffMini',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('v1/accounts/staff-mini/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const staffSlice = createSlice({
    name: 'staff',
    initialState: {
        staffMini: [],
        staffs: {
            results: []
        },
        staffLoading: false,
        staffError: null,
        staffSuccess: false,
        staffProfile: null
    },
    reducers: {
        clearStaff: (state) => {
            state.staffLoading = false;
            state.staffError = null;
            state.staffSuccess = false;
            state.staffProfile = null;
        }
    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchStaffs.pending, (state) => {
            state.staffLoading = true;
            state.staffError = null;
          })
          .addCase(fetchStaffs.fulfilled, (state, action) => {
            state.staffLoading = false;
            state.staffs = action.payload;
          })
          .addCase(fetchStaffs.rejected, (state, action) => {
            state.staffLoading = false;
            state.staffError = action.payload || "Cannot fetch staffs";
          })
          .addCase(createStaff.pending, (state) => {
            state.staffLoading = true;
            state.staffError = null;
            state.staffSuccess = false;
          })
          .addCase(createStaff.fulfilled, (state, action) => {
            state.staffLoading = false;
            state.staffSuccess = true;
            
            if (state.staffs?.results) {
              state.staffs.results.push(action.payload);
              state.staffs.count += 1;
            } else {
              state.staffs = {
                results: [action.payload],
                count: 1
              };
            }
          })
          .addCase(createStaff.rejected, (state, action) => {
            state.staffLoading = false;
            state.staffSuccess = false;

            const payload = action.payload;

            if (typeof payload === 'object' && payload !== null) {
              const allMessages = Object.values(payload)
                .flat()
                .join(', ');
              state.staffError = allMessages;
            } else {
              state.staffError = payload || "Cannot create staff";
            }

          })
          .addCase(updateStaff.pending, (state) => {
            state.staffLoading = true;
            state.staffError = null;
            state.staffSuccess = false;
          })
          .addCase(updateStaff.fulfilled, (state, action) => {
            state.staffLoading = false;
            state.staffSuccess = true;
          })
          .addCase(updateStaff.rejected, (state, action) => {
            state.staffLoading = false;
            state.staffSuccess = false;

            const payload = action.payload;

            if (typeof payload === 'object' && payload !== null) {
              const allMessages = Object.values(payload)
                .flat()
                .join(', ');
              state.staffError = allMessages;
            } else {
              state.staffError = payload || "Cannot update staff";
            }

          })
          .addCase(fetchStaff.pending, (state) => {
            state.staffLoading = true;
            state.staffError = null;
          })
          .addCase(fetchStaff.fulfilled, (state, action) => {
            state.staffLoading = false;
            state.staffProfile = action.payload;
          })
          .addCase(fetchStaff.rejected, (state, action) => {
            state.staffLoading = false;

            // Extract the actual error message
            const error = action.payload?.detail || "Cannot fetch profile";
            state.staffError = error;
          })
          .addCase(fetchStaffMini.fulfilled, (state, action) => {
            state.staffMini = action.payload;
          })
          .addCase(fetchStaffMini.rejected, (state, action) => {
            state.staffError = action.payload || "Cannot fetch staffs";
          })
    }
});

export const { clearStaff } = staffSlice.actions;
export default staffSlice;